import React from "react";
import i18n from "../../../i18n/i18n";
import Table from "../../../common/components/shared/table/table";
import Loader from "../../../common/components/shared/loader/loader";
import {Api} from "../../../helpers/api";
import {HttpError} from "../../../common/components/shared/httpError/httpError";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import {PlaceOwnedVehicleService} from "../../services/placeOwnedVehicleService";
import {PlaceOwnedVehicleModel} from "../../models/placeOwnedVehicle";
import ReloadButton from "../../../common/components/shared/reloadButton/reloadButton";
import "./placeOwnedVehicleList.scss";
import {NavLink} from "react-router-dom";
import {routingAddresses} from "../../../helpers/routing";

interface PlaceOwnedVehicleListState {
    ownedVehicleListData: PlaceOwnedVehicleModel[] | undefined | null;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    selectedElementId: string;
    currentPage: number;
    isTableLoader: boolean;
}

export default class PlaceOwnedVehicleList extends React.Component <any, PlaceOwnedVehicleListState> {
    constructor(props: any) {
        super(props);

        this.state = {
            ownedVehicleListData: undefined,
            response: undefined,
            selectedElementId: "",
            currentPage: 0,
            isTableLoader: false
        };
    }

    get ownedVehicleListData() {
        return this.state.ownedVehicleListData;
    }

    public async componentDidMount() {
        await this.getAllOwnedVehiclesInPlace();
    }

    public render(): JSX.Element {
        const properties = ["regNo", "usedBy", "orderNo"];
        const headers = properties.map(key => i18n.t("place.ownedVehicles.headers." + key));

        return (
            <div className="owned-vehicle-list">
                {this.renderWrapperContent(headers, properties)}
            </div>
        );
    }

    private renderActions(element: PlaceOwnedVehicleModel): JSX.Element {
        // @ts-ignore
        const elementOrderId = element.orderId;

        return (
            <>
                {elementOrderId && (
                    <>
                        <NavLink
                            to={`${routingAddresses.order.details}/${element.orderId}`}
                            className="action-button"
                            data-testid={`preview-${element.orderId}`}
                        >
                            {i18n.t("place.ownedVehicles.orderDetailAction")}
                        </NavLink>
                    </>
                )}
            </>
        );
    }

    private renderWrapperContent(headers: string[], properties: string[]) {
        if (!Api.isSuccess(this.state.response)) {
            return (
                <HttpError
                    response={this.state.response}
                    cause={i18n.t("place.ownedVehicles.retrievalErrorSuffix")}
                />
            );
        } else {
            if (this.ownedVehicleListData === undefined) {
                return <Loader/>;
            } else {
                return (
                    <>
                        {this.renderHeader()}
                        <div className="owned-vehicle-list-content">
                            {this.ownedVehicleListData && this.ownedVehicleListData!.length && this.ownedVehicleListData!.length > 0 ? (
                                <Table
                                    headers={headers}
                                    rows={this.ownedVehicleListData}
                                    properties={properties}
                                    testId="owned-vehicles-table"
                                    actions={this.renderActions.bind(this)}
                                    pageable={true}
                                    numberOfElements={this.state.ownedVehicleListData!.length}
                                    currentPage={this.state.currentPage}
                                    isOldPagination
                                    isTableLoader={this.state.isTableLoader}
                                />
                            ) : (
                                <Table
                                    headers={headers}
                                    rows={[]}
                                    properties={properties}
                                    testId={"owned-vehicles-table"}
                                    currentPage={this.state.currentPage}
                                    numberOfElements={0}
                                />
                            )}
                        </div>
                    </>
                );
            }
        }
    }

    private renderHeader() {
        return (
            <div className="header">
                <div className="actions">
                    <ReloadButton
                        reloadFunc={this.reload.bind(this)}
                        testId="place-owned-vehicle-list-reload-btn"
                    />
                </div>
            </div>
        );
    }

    private async getAllOwnedVehiclesInPlace() {
        this.setState({
            isTableLoader: true
        });

        const response = await PlaceOwnedVehicleService.getAll();

        this.setState({
            ownedVehicleListData: response?.data?.data || null,
            response,
            currentPage: response?.data?.currentPage,
            isTableLoader: false
        });
    }

    private async reload() {
        this.setState({ownedVehicleListData: undefined});
        await this.getAllOwnedVehiclesInPlace();
    }
}


